import { createAction, props } from '@ngrx/store';
import { Weather } from '../../components/weather/weather.service';

export const FetchWeatherData = createAction('[Weather] Fetch weather data');
export const UpdateWeatherData = createAction('[Weather] Update weather data', props<{ weather: Weather }>());
